import { isE2E } from '@/config/utils';

/**
 * Resolves the React Router basename for the current deployment.
 *
 * The basename must match the URL path the app is actually served from. If it
 * doesn't, client-side routing builds links against the wrong prefix and every
 * route 404s — hence we switch it per deployment.
 *
 * Only the Playwright suite on the CI build server (Gradle/Jenkins) needs a
 * non-empty basename: there the app runs as the production WAR in Jetty under
 * the `/connect/public` context path, so routes must be prefixed to match.
 * Local Playwright (port 4444), local dev, and production (served at the root
 * behind the reverse proxy) all use an empty basename.
 *
 * We identify the CI WAR by combining the Playwright marker (`isE2E()`,
 * injected by the test fixture) with the `/connect/public` path — a pairing
 * that only ever holds on CI, never under local Playwright.
 */
export const getBasename = (): string => {
  // CI WAR only: Playwright running behind the Jetty /connect/public context path.
  if (isE2E() && window.location.pathname.startsWith('/connect/public')) {
    return '/connect/public';
  }

  return '';
};
